export default "__VITE_ASSET__BVn29U1c__"